  <div class="terms-model">
    <div class="itop-header">
      <div class="parkinglot-model">
        <h4>Parking Location Terms & Conditions
        </h4>
         <img src="assets/images/export-close.svg" (click)="closeDialog()" alt="Close"/>
     </div>
        <div class="terms-text">
          <div class="attachment-img" [innerHTML]="(termsAndCondition)"></div>
        </div>
     <div *ngIf="termAndConditionFilePath" class="doc-outer">
      <a [href]="termAndConditionFilePath" target="_blank">
        <img src="assets/images/google-docs.svg" alt="Google Docs" />
        <p>Parking Location Terms & Conditions.</p>
      </a>
     </div>
    </div>